<template>
  <div class="slideDownSelect">
    <h3>
      <template v-if="isSeason"> 其他赛季 </template>
      <template v-else>
        {{ title }}
      </template>
    </h3>
    <div @click="handleClick">
      <arrow :isShow="isShow" />
    </div>
    <ul :class="[widthSty ? 'slideWidth' : '']" v-if="isShow">
      <template v-for="(item, index) in slideData">
        <li
          v-if="(index !== currentIndex && isSeason) || !isSeason"
          @click="change(index)"
        >
          {{ item.name }}
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import Arrow from "./arrow.vue";
export default {
  name: "slideDownSelect",
  components: {
    Arrow,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    isSeason: {
      type: Boolean,
      default: false,
    },

    slideData: {
      type: Array,
      default: [],
    },
    widthSty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rotateDeg: 135,
      isShow: false,
      currentIndex: 0,
    };
  },
  methods: {
    handleClick() {
      this.isShow = !this.isShow;
      // if (this.isShow) {
      //   this.rotateDeg = -45;
      // } else {
      //   this.rotateDeg = 135;
      // }
    },
    change(index) {
      this.currentIndex = index;
      let item = this.slideData[index];
      this.$emit("change", { index, item });
      this.isShow = false;
      // this.rotateDeg = 135;
    },
  },
  // computed: {
  //   currentIndex() {
  //     let teamInfo = JSON.parse(localStorage.getItem("teamInfo"));
  //     let name = teamInfo.cupName.replace("松鼠杯", "");
  //     this.slideData.forEach((e, index) => {
  //       if (e.name == name) {
  //         return index;
  //       }
  //     });
  //   },
  // },
  watch: {
    slideData(newVal, oldVal) {
      // let teamInfo = JSON.parse(localStorage.getItem("teamInfo"));
      // let name = teamInfo.cupName.replace("松鼠杯", "");
      if (this.isSeason) {
        newVal.forEach((e, index) => {
          console.log(index);
          console.log(e);
          if (e.name == this.title) {
            this.currentIndex = index;
          }
        });
        console.log(this.currentIndex);
      }
    },
  },
  mounted() {
    // let teamInfo = JSON.parse(localStorage.getItem("teamInfo"));
    // let name = teamInfo.cupName.replace("松鼠杯", "");
    // console.log(name);
    // this.$nextTick(function () {
    //   // 在DOM更新后执行的代码
    //   // 可以操作更新后的DOM元素
    //   if (this.isSeason) {
    //     this.slideData.forEach((e, index) => {
    //       console.log(index);
    //       console.log(e);
    //       if (e.name == name) {
    //         this.currentIndex = index;
    //       }
    //     });
    //     console.log(this.currentIndex);
    //     console.log(this.slideData);
    //   }
    // });
    // this.slideData.forEach((e, index) => {
    //   if (e.name == name) {
    //     this.currentIndex = index;
    //   }
    // });
  },
};
</script>

<style lang="less" scoped>
.slideDownSelect {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  position: relative;
  h3 {
    margin: 0 18px 0 0;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #68707d;
    line-height: 40px;
    text-align: right;
  }
  ul {
    width: 208px;
    max-height: 300px;
    overflow: auto;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    border: 1px solid #e6e6e6;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #68707d;
    line-height: 40px;
    position: absolute;
    top: 40px;
    right: 0;
    z-index: 3;
    border: 1px solid #e6e6e6;
    background: #ffffff;
    padding: 24px;
    min-width: 5em;
    margin-top: 10px;

    li {
      margin-bottom: 5px;
      text-align: center;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .slideWidth{
    width: 300px;
  }
}
</style>
